import { Component } from "@angular/core";
import { BreadCrumbService } from "@services/breadcrumb.service";
import { Observable } from 'rxjs';

interface Breadcrumb {
	label: string;
	url: string;
}

@Component({
	selector: "app-breadcrumb",
	templateUrl: "./breadcrumb.component.html",
	styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent {
	breadcrumbs$: Observable<Breadcrumb[]>;

	constructor(private breadcrumbService: BreadCrumbService) {
		this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
	}
}
